/* Whiteboard Actions */
// export const SET_SHOW_WHITEBOARD = "SET_SHOW_WHITEBOARD";
export const SAVE_WHITEBOARD_LAYERS = "SAVE_WHITEBOARD_LAYERS";
export const SAVE_WHITEBOARD_BACKGROUND = "SAVE_WHITEBOARD_BACKGROUND";
